import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { PeopleModel } from '@files/permissions/permissions.model';
import { PermissionsService } from '@files/permissions/permissions.service';
import { SelectPeopleParameters } from '@files/select-people-dialog/select-people-dialog.model';
import { Permission } from '@models/permission';
import { SearchableListBoxConfig, SearchableListItemType } from '@shared/components/searchable-listbox';
import { SearchableListboxComponent } from '@shared/components/searchable-listbox/searchable-listbox.component';
import { CipoDialogHeaderComponent } from '@shared/dialogs';

const keySeparator = '_';

@Component({
  selector: 'app-select-people-dialog',
  imports: [
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    FlexLayoutModule,
    MatButtonModule,
    MatButtonToggleModule,
    SearchableListboxComponent,
    CipoDialogHeaderComponent,
  ],
  templateUrl: './select-people-dialog.component.html',
})
export class SelectPeopleDialogComponent {
  permissionsService = inject(PermissionsService);
  translate = inject(TranslateService);
  readonly dialogRef = inject(MatDialogRef<SelectPeopleDialogComponent>);
  readonly data = inject<SelectPeopleParameters>(MAT_DIALOG_DATA);

  notContractModule: boolean = false;
  folderId: number;
  fileId: number;
  fileParentFolderId: number;
  entityInstanceId: number;
  allow = true;
  listBoxConfig = signal<SearchableListBoxConfig>({
    columns: 2,
    multiple: true,
    searchable: true,
    noFoundMessage: 'fileFolderPermissions.notFound',
  });
  listBoxOptions = signal<SearchableListItemType<string>[]>(null);
  listBoxValues = signal<string[]>([]);

  constructor() {
    this.folderId = this.data.folderId;
    this.fileId = this.data.fileId;
    this.fileParentFolderId = this.data.fileParentFolderId;
    this.entityInstanceId = this.data.entityInstanceId;
    this.notContractModule = this.data.notContractModule;

    this.loadAvailablePeople(this.allow);
  }

  loadAvailablePeople(allow: boolean) {
    this.listBoxOptions.set(null);
    this.listBoxValues.set([]);
    this.permissionsService
      .getAvailableUserRoles(this.folderId, this.fileId, this.fileParentFolderId, this.entityInstanceId, allow)
      .subscribe(list => {
        const options = list.map(l => ({
          key: `${l.id}${keySeparator}${l.isUser}`,
          value: l.name,
          prefixIcon: l.isUser ? 'person' : 'groups',
        }));
        this.listBoxOptions.set(options);
      });
  }

  returnPeople() {
    const list: PeopleModel[] = this.listBoxValues()
      .map(l => l.split(keySeparator))
      .map(arr => ({
        id: Number(arr[0]),
        isUser: arr[1].toLowerCase() === 'true',
        isNew: true,
        name: this.listBoxOptions().find(p => p.key == arr.join(keySeparator))?.value ?? '',
        permissions: [
          {
            permissionId: Permission.Read,
            permission: Permission[Permission.Read],
            allow: !this.notContractModule && this.allow,
            deny: !this.allow,
          },
        ],
      }));
    this.dialogRef.close(list);
  }
}
